/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { device } from 'src/styles/global';
import theme from 'src/styles/theme';

interface Props {
  $isActive: boolean;
  $isSelected: boolean;
  $hasError: boolean;
  $alreadyTrackedSongs: boolean;
}

export const BatchSelectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid ${theme.colors.neutralW80};
  padding: 24px 24px 16px 24px;

  @media ${device.mobile} {
    padding: 24px 16px 16px 16px;
  }
`;

export const CheckboxStyles = {
  borderColor: theme.colors.neutralW30,
  marginRight: '16px',
};

export const BatchDescWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SongListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 336px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: none;
  }

  &::-webkit-scrollbar-thumb {
    background: ${theme.colors.neutralW90};
    border-radius: 10px;
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: ${theme.colors.neutralW90};
`;

export const TooltipContainerStyles = {
  display: 'flex',
  width: 'fit-content',
  maxWidth: '240px',
  minHeight: '5px',
  whiteSpace: 'wrap',
  fontSize: '12px',
  fontWeight: '700',
  borderRadius: '5px',
  marginTop: '-28px',
  padding: '4px 8px',
};

export const SongItemWrapper = styled.div<Props>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  gap: 16px;
  cursor: pointer;

  background: ${({ $isActive, $isSelected, $hasError }) =>
    $hasError
      ? theme.colors.error100
      : $isActive || $isSelected
      ? theme.colors.mtr100
      : ''};

  &:hover {
    background: ${theme.colors.neutralW100};
  }

  &:active {
    background: ${theme.colors.mtr100};
  }

  @media ${device.mobile} {
    padding: 16px;
    gap: 8px;
  }
`;

export const SongSelectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const IconWrapper = styled.div`
  svg {
    cursor: pointer;
    width: 18px;
    height: 18px;
    z-index: 999;
  }
`;

export const SongInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SongTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${theme.colors.neutralW40};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  word-break: break-word;
`;

export const ArtistName = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${theme.colors.neutralW40};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  word-break: break-word;
`;

export const ReleaseSongItemWrapper = styled.div<Props>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  gap: 16px;
  cursor: ${({ $alreadyTrackedSongs }) =>
    $alreadyTrackedSongs ? '' : 'pointer'};

  background: ${({ $isActive, $isSelected, $hasError, $alreadyTrackedSongs }) =>
    $hasError
      ? theme.colors.error100
      : $alreadyTrackedSongs
      ? ''
      : $isActive || $isSelected
      ? theme.colors.mtr100
      : ''};

  &:hover {
    background: ${({ $alreadyTrackedSongs }) =>
      $alreadyTrackedSongs ? '' : theme.colors.neutralW100};
  }

  &:active {
    background: ${({ $alreadyTrackedSongs }) =>
      $alreadyTrackedSongs ? '' : theme.colors.mtr100};
  }

  @media ${device.mobile} {
    padding: 16px;
    gap: 8px;
  }
`;

export const ReleaseSongTitle = styled.div<Props>`
  font-size: 14px;
  font-weight: 700;
  color: ${({ $alreadyTrackedSongs }) =>
    $alreadyTrackedSongs ? theme.colors.neutralW80 : theme.colors.neutralW40};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  word-break: break-word;
`;

export const ReleaseArtistName = styled.div<Props>`
  font-size: 12px;
  font-weight: 400;
  color: ${({ $alreadyTrackedSongs }) =>
    $alreadyTrackedSongs ? theme.colors.neutralW80 : theme.colors.neutralW40};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-word;
`;

export const ReleaseNameTag = styled.div<Props>`
  font-size: 12px;
  font-weight: 400;
  color: ${({ $alreadyTrackedSongs }) =>
    $alreadyTrackedSongs ? theme.colors.neutralW80 : theme.colors.neutralW40};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-word;
`;

export const AlreadyTrackedIconWrapper = styled.div`
  svg {
    width: 18px;
    height: 18px;
    z-index: 999;
  }
`;
